"use client";
import Header from "@/components/organisms/Header";
import Footer from "@/components/organisms/Footer";
import { SearchTrendItem } from "@/services/search-trends/types";
import { HeaderProps } from "@/page-builder/global/mappers/header.mapper";
import { FooterProps } from "@/page-builder/global/mappers/footer.mapper";

interface LayoutDataProps {
  children: React.ReactNode;
  headerData: HeaderProps;
  footerData: FooterProps;
  searchTrends: SearchTrendItem[];
}

export default function ClientLayout({
  children,
  headerData,
  footerData,
  searchTrends,
}: LayoutDataProps) {
  return (
    <>
      <Header
        topBar={headerData?.topBar}
        logo={headerData?.logo}
        menuItems={headerData?.menuItems}
        ctaButton={headerData?.ctaButton}
        searchTrends={searchTrends}
      />
      <main id="main" tabIndex={-1} className="min-h-screen pb-32 md:pb-[44px] xl:pb-64">{children}</main>
      <Footer
        help={footerData?.help}
        floatingCard={footerData?.floatingCard}
        main={footerData?.main}
      />
    </>
  );
}
